import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ForumTopic } from '../api/opoint.schemas';
import { Card } from '@/components/ui/card';
import { FaLock, FaComments } from 'react-icons/fa';
import { formatDate } from '@/utils';

interface ProjectCardProps {
  topic: ForumTopic;
}

const ProjectCard: React.FC<ProjectCardProps> = ({ topic }) => {
  const navigate = useNavigate();

  const category =
    topic.category?.topic_id === topic.id
      ? topic.category.parent_category
      : topic.category;

  return (
    <Card
      className='px-10 cursor-pointer hover:shadow-lg font-bold border-1 border-black flex justify-between'
      style={{
        color: 'var(--opoint-grey)',
        minWidth: '100%',
        minHeight: '200px',
      }}
      onClick={() => navigate(`/projects/${topic.id}`)}
    >
      <div className='flex items-center justify-between'>
        {topic.closed ? <FaLock className='ml-2 text-grey-600' /> : <div />}
        <div className='flex items-center justify-end'>
          <p className='text-sm font-bold'>{category?.name}</p>
          <span
            className='w-3 h-3 rounded-full ml-2'
            style={{ backgroundColor: `#${category?.color}` }}
          ></span>
        </div>
      </div>
      <h2
        className={`text-lg font-semibold ${topic.closed ? 'text-grey-600' : 'text-black'} text-center`}
      >
        {topic.name}
      </h2>
      <div className='flex justify-between items-center'>
        <div className='flex items-center'>
          <p className='text-sm'>{formatDate(topic.created_at)}</p>
          <div className='flex items-center text-gray-500 text-sm ml-4'>
            <FaComments className='mr-1' />
            {topic.posts_count}
          </div>
        </div>
        <p className='text-gray-500 text-sm'>
          {topic.assigned_to ? `@${topic.assigned_to}` : ''}
        </p>
      </div>
    </Card>
  );
};

export default ProjectCard;
